<app-navbar></app-navbar>

<section class="min-h-[50dvh] bg-white text-black">
    <div class="w-full">
        <figure class="relative">
            <img src="/assets/img/excellence/tire_knowledge/65a7b841e64da8a2cc35cad5_readtires-65a7b82542fc6-p-1080.webp" alt="poster image" 
            class="object-cover bg-center w-full h-[60dvh] md:h-[45dvh]"/>
            <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-neutral-950 text-left mx-auto pb-14">
                <div class="max-w-3xl xl:max-w-6xl mx-auto items-center justify-center">
                    <a routerLink="/excellence/tire-knowledge" href="/excellence/tire-knowledge" class="text-green-500 font-semibold text-lg hover:underline">{{back}}</a>
                    <h3 class="text-5xl md:text-6xl font-bold text-green-500">{{texts.title}}</h3>
                    <p class="text-2xl opacity-75 mx-auto">{{texts.subtitle}}</p>
                
                </div>
                
            </figcaption>
        </figure>
    </div>

    <div class="max-w-3xl xl:max-w-6xl mx-4 md:mx-auto py-10">
        <div class="text-justify mb-10">
            <div>
                <h2 class="text-lg mb-4">{{texts.body[0]}}</h2>
                <p class="text-lg">
                    {{texts.body[1]}}:
                </p>
                <div class="items-center justify-center mx-auto">                
                    <img src="src/assets/img/excellence/tire_knowledge/65a93dff429528ae893a1d3e_HowReadTire.webp" 
                    alt="img tires" srcset="img tires diagram" class="w-full lg:w-1/2 mx-auto">
                </div>
                <p class="text-lg mb-2">
                    {{texts.body[2]}}
                </p>
                <p class="text-lg mb-2">
                    {{texts.body[3]}}
                </p>
                <p class="text-lg mb-4">
                    {{texts.body[4]}}
                </p>
                <div class="ms-8">
                    <ol class="list-disc">
                        @for (item of texts.body[5]; track $index) {
                            <li class="text-base list-item my-2" >
                                {{item}}
                            </li>
                        }
                        
                    </ol>
                </div>
            </div>
            <div>
                <p class="text-lg mb-2">
                    {{texts.body[6]}}
                </p>
                <p class="text-lg mb-4">
                    {{texts.body[7]}}
                </p>
                <div class="items-center justify-center mx-auto">                
                    <img src="src/assets/img/excellence/tire_knowledge/table-codes.png" 
                    alt="img tires" srcset="img tires diagram" class="w-full lg:w-2/5 mx-auto">
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>